var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userMain"},[_c('keepAlive',[_c('Header')],1),_c('div',{staticClass:"banxin clear userCenter"},[_c('keepAlive',[_c('LeftNav')],1),_c('router-view')],1),_c('keepAlive',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }